import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous, safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetEmailTemplateGroups as GetEmailTemplateGroupsQuery,
    GetEmailTemplateGroupsVariables as GetEmailTemplateGroupsQueryVariables,
} from 'nutshell-graphql-types';

import type {Template, TemplateGroup} from '../../types';

import GET_EMAIL_TEMPLATE_GROUPS from '../queries/get-email-template-groups.graphql';

export const useGetEmailTemplateGroups = ({
    search,
    creatorIds,
    onlyArchived,
    includeShared,
    includeUnsharedFromOthers,
}: {
    search?: string;
    creatorIds?: string[];
    onlyArchived?: boolean;
    includeShared?: boolean;
    includeUnsharedFromOthers?: boolean;
}): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    groups: TemplateGroup[];
    uncategorized: Template[];
    count: number;
    recentlySent: Template[];
    refetch: () => Promise<any>;
    networkStatus: number;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetEmailTemplateGroupsQuery,
        GetEmailTemplateGroupsQueryVariables
    >(GET_EMAIL_TEMPLATE_GROUPS, {
        variables: {
            creatorIds,
            search,
            onlyArchived,
            includeShared,
            includeUnsharedFromOthers,
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
    });

    const {emailSequenceTemplateGroups} = makeDataDangerous(data);
    const groups =
        emailSequenceTemplateGroups && emailSequenceTemplateGroups.groups
            ? emailSequenceTemplateGroups.groups
            : [];
    const uncategorized =
        emailSequenceTemplateGroups && emailSequenceTemplateGroups.uncategorized
            ? emailSequenceTemplateGroups.uncategorized
            : [];
    const recentlySent =
        emailSequenceTemplateGroups && emailSequenceTemplateGroups.recentlySent
            ? emailSequenceTemplateGroups.recentlySent
            : [];

    let count = 0;
    // @ts-expect-error
    groups.forEach((group) => {
        count += group.emailSequenceTemplates.length;
    });
    count += uncategorized.length;

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        count,
        groups,
        uncategorized,
        recentlySent,
        refetch,
        networkStatus,
    };
};
